import React from "react";
import Nav from "react-bootstrap/Nav";
import { useMobileMode } from "./MobileModeContext.jsx";

/**
 * Today's menu bar (App.jsx NavBar) on a phone-width screen only: the way back to the phone
 * layout after "Use desktop layout", and (unlocked admins) "Try the phone app" before it is
 * switched on for everyone. A desktop-width screen never shows either.
 */
export default function PhoneNavItems({ isAdminActive }) {
  const mobile = useMobileMode();
  const showUsePhone = mobile.phoneWidth && mobile.prefs.forceDesktop
    && (mobile.mobileFeature.enabled || mobile.prefs.preview);
  const showTryPhone = mobile.phoneWidth && isAdminActive && !mobile.prefs.forceDesktop
    && !mobile.mobileFeature.enabled && !mobile.prefs.preview;
  return (
    <>
      {showUsePhone && (
        <Nav.Link as="button" type="button" onClick={() => mobile.setForceDesktop(false)}>
          <i className="fas fa-mobile-alt me-1"></i> Use phone layout
        </Nav.Link>
      )}
      {showTryPhone && (
        <Nav.Link as="button" type="button" onClick={() => mobile.setPreview(true)}>
          <i className="fas fa-flask me-1"></i> Try the phone app (preview)
        </Nav.Link>
      )}
    </>
  );
}
